import { HFlow, Tabs, Tag } from 'bold-ui'
import { Breadcrumb } from 'components/breadcrumb'
import { PageContent } from 'components/layout/PageContent'
import { PageHeaderSection } from 'components/PageHeaderSection'
import { PecSwitch, TabLink } from 'components/route'
import { useEquipeDetailQuery } from 'graphql/hooks.generated'
import { useRouter } from 'hooks/useRouter'
import React from 'react'
import { Redirect, Route } from 'react-router'
import { ProfissionalTable } from 'view/profissional/list/ProfissionalTable'

export interface UrlParams {
  equipeId: string
}

export interface EquipeDetailRootViewProps {
  unidadeSaudeId: ID
}

export function EquipeDetailRootView(props: EquipeDetailRootViewProps) {
  const { unidadeSaudeId } = props
  const { match } = useRouter<UrlParams>()
  const { equipeId } = match.params

  const {
    data: { equipe },
  } = useEquipeDetailQuery({
    variables: { id: equipeId },
  })

  const renderProfissionais = () => {
    return <ProfissionalTable initialFilter={{ equipesId: [equipeId] }} />
  }

  if (!equipe) {
    return null
  }

  return (
    <>
      <Breadcrumb title='Visualização' to={`/unidadeSaude/${unidadeSaudeId}/equipes`} />
      <Breadcrumb title='Visualização de equipe' />

      <PageHeaderSection
        title={
          <HFlow alignItems='center'>
            <h1>{equipe.nome + ' - ' + equipe.ine}</h1>
            {!equipe.ativo && <Tag style={{ fontSize: '0.75rem' }}>Inativa</Tag>}
          </HFlow>
        }
        subtitle={`Área ${equipe.area}`}
      >
        <Tabs>
          <TabLink to={`${match.url}/profissionais`}>Profissionais</TabLink>
        </Tabs>
      </PageHeaderSection>

      <PageContent>
        <PecSwitch>
          <Redirect exact path={`${match.url}`} to={`${match.url}/profissionais`} />
          <Route exact path={`${match.url}/profissionais`} render={renderProfissionais} />
        </PecSwitch>
      </PageContent>
    </>
  )
}
